import { useState } from "react";
import { useTimeLimit } from "./TimeLimitProvider";
import { PinPad } from "./PinPad";
import { useT } from "../i18n/LocaleProvider";

/** Shown when the "keep full screen" lock is on but the app is not fullscreen
 *  (e.g. the child pressed Escape). Tapping returns to fullscreen; a grown-up
 *  can enter the PIN to turn the lock off and leave. */
export function FullscreenGate() {
  const t = useT();
  const { hasPin, enterFullscreen, verifyPin, setFsLock, registerPinAttempt, pinHint } =
    useTimeLimit();
  const [entering, setEntering] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="lock-overlay" role="dialog" aria-modal="true" aria-label={t.fsAria}>
      <div className="lock-card">
        <div className="lock-emoji" aria-hidden="true">
          🖍️
        </div>
        <h2>{t.fsTitle}</h2>
        <p>{t.fsBody}</p>
        <button className="pill-btn" onClick={enterFullscreen}>
          {t.fsBackBtn}
        </button>
        {!entering ? (
          <button
            className="tl-action fsg-exit"
            onClick={() => {
              // With no grown-up code set there's nothing to verify — asking for
              // one would trap the grown-up (every code is "wrong", no hint ever
              // shows). Just leave, like the double-Escape exit prompt does.
              if (!hasPin) {
                setFsLock(false);
                return;
              }
              setEntering(true);
              setError(null);
            }}
          >
            {t.fsGrownUpExit}
          </button>
        ) : (
          <>
            <p className="lock-prompt">{t.fsEnterCode}</p>
            <PinPad
              onComplete={(code) => {
                const ok = verifyPin(code);
                registerPinAttempt(ok);
                if (ok) setFsLock(false);
                else setError(t.lockWrongCode);
              }}
              error={error}
              hint={pinHint}
            />
          </>
        )}
      </div>
    </div>
  );
}
